import Tags from "./Tags";

export { default as Tag } from "./Tag";
export { EditableTag, StyledTag, TagLabel, Count, TAG_SIZE } from "./Tag";
export { default as TagDuration } from "./TagDuration";
export { default as TagComplete } from "./TagComplete";
export { default as TagIncomplete } from "./TagIncomplete";
export { default as TagTicker } from "./TagTicker";
export { default as TagList } from "./TagList";
export { default as TagOptional } from "./TagOptional";

export default Tags;
